import React, { useState } from 'react';
import { MapPin, Home, Bed } from 'lucide-react';

const PropertyFilters = ({ onFilterChange, initialFilters }) => {
  const [filters, setFilters] = useState(initialFilters || {
    location: 'JLT',
    bedrooms: '1',
    propertyType: 'Apartment'
  });

  const dubaiLocations = [
    { value: 'JLT', label: 'Jumeirah Lake Towers (JLT)' },
    { value: 'Dubai Marina', label: 'Dubai Marina' },
    { value: 'Business Bay', label: 'Business Bay' },
    { value: 'Downtown Dubai', label: 'Downtown Dubai' },
    { value: 'Jebel Ali', label: 'Jebel Ali' },
    { value: 'Palm Jumeirah', label: 'Palm Jumeirah' },
    { value: 'Dubai Hills Estate', label: 'Dubai Hills Estate' },
    { value: 'Arabian Ranches', label: 'Arabian Ranches' },
    { value: 'JBR', label: 'JBR (Jumeirah Beach Residence)' },
    { value: 'Dubai Sports City', label: 'Dubai Sports City' },
    { value: 'Motor City', label: 'Motor City' },
    { value: 'International City', label: 'International City' }
  ];

  const bedroomOptions = [
    { value: 'Studio', label: 'Studio' },
    { value: '1', label: '1 Bedroom' },
    { value: '2', label: '2 Bedrooms' },
    { value: '3', label: '3 Bedrooms' },
    { value: '4', label: '4 Bedrooms' },
    { value: '5+', label: '5+ Bedrooms' }
  ];

  const propertyTypes = [
    { value: 'Apartment', label: 'Apartment' },
    { value: 'Villa', label: 'Villa' },
    { value: 'Townhouse', label: 'Townhouse' },
    { value: 'Penthouse', label: 'Penthouse' },
    { value: 'Duplex', label: 'Duplex' }
  ];

  const handleFilterChange = (field, value) => {
    const newFilters = { ...filters, [field]: value };
    setFilters(newFilters);
    onFilterChange(newFilters);
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">
        Find Your Perfect Property
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Location Filter */}
        <div>
          <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
            <MapPin className="w-4 h-4 text-teal-600" />
            Location in Dubai
          </label>
          <select
            value={filters.location}
            onChange={(e) => handleFilterChange('location', e.target.value)}
            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
          >
            {dubaiLocations.map((loc) => (
              <option key={loc.value} value={loc.value}>
                {loc.label}
              </option>
            ))}
          </select>
        </div>

        {/* Bedrooms Filter */}
        <div>
          <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
            <Bed className="w-4 h-4 text-teal-600" />
            Bedrooms
          </label>
          <select
            value={filters.bedrooms}
            onChange={(e) => handleFilterChange('bedrooms', e.target.value)}
            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
          >
            {bedroomOptions.map((bed) => (
              <option key={bed.value} value={bed.value}>
                {bed.label}
              </option>
            ))}
          </select>
        </div>

        {/* Property Type Filter */}
        <div>
          <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
            <Home className="w-4 h-4 text-teal-600" />
            Property Type
          </label>
          <select
            value={filters.propertyType}
            onChange={(e) => handleFilterChange('propertyType', e.target.value)}
            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
          >
            {propertyTypes.map((type) => (
              <option key={type.value} value={type.value}>
                {type.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="mt-4 flex items-center gap-2 text-sm text-gray-600">
        <span className="inline-flex items-center gap-1 px-3 py-1 bg-teal-50 text-teal-700 rounded-full">
          <span className="font-medium">Showing:</span> {filters.bedrooms === 'Studio' ? 'Studio' : `${filters.bedrooms} BR`} {filters.propertyType} in {filters.location}
        </span>
      </div>
    </div>
  );
};

export default PropertyFilters;
